export default {
  dayNames: ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado'],
  dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
  dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
  monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
  monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
  today: 'Hoy',
  clear: 'Limpiar',
  weekHeader: 'Sm',
  firstDayOfWeek: 1,
  dateFormat: 'dd/mm/yy',
  weak: 'Debil',
  medium: 'Medio',
  strong: 'Fuerte',
  passwordPrompt: 'Ingrese una contrasena',
  emptyMessage: 'No hay resultados',
  emptyFilterMessage: 'No hay resultados',
  pending: 'Pendiente',
  chooseYear: 'Elegir ano',
  chooseMonth: 'Elegir mes',
  chooseDate: 'Elegir fecha',
  prevDecade: 'Decada anterior',
  nextDecade: 'Decada siguiente',
  prevYear: 'Ano anterior',
  nextYear: 'Ano siguiente',
  prevMonth: 'Mes anterior',
  nextMonth: 'Mes siguiente',
  prevHour: 'Hora anterior',
  nextHour: 'Hora siguiente',
  prevMinute: 'Minuto anterior',
  nextMinute: 'Minuto siguiente',
  prevSecond: 'Segundo anterior',
  nextSecond: 'Segundo siguiente',
  am: 'am',
  pm: 'pm',
  selectionMessage: '{0} elementos seleccionados',
  emptySelectionMessage: 'Ningun elemento seleccionado',
  emptySearchMessage: 'No hay resultados',
  aria: {
    trueLabel: 'Verdadero',
    falseLabel: 'Falso',
    nullLabel: 'No seleccionado',
    star: '1 estrella',
    stars: '{star} estrellas',
    selectAll: 'Todos los elementos seleccionados',
    unselectAll: 'Todos los elementos deseleccionados',
    close: 'Cerrar',
    previous: 'Anterior',
    next: 'Siguiente',
    navigation: 'Navegacion',
    scrollTop: 'Desplazar arriba',
    moveTop: 'Mover al principio',
    moveUp: 'Mover arriba',
    moveDown: 'Mover abajo',
    moveBottom: 'Mover al final',
    moveToTarget: 'Mover al destino',
    moveToSource: 'Mover al origen',
    moveAllToTarget: 'Mover todo al destino',
    moveAllToSource: 'Mover todo al origen',
    pageLabel: 'Pagina {page}',
    firstPageLabel: 'Primera pagina',
    lastPageLabel: 'Ultima pagina',
    nextPageLabel: 'Pagina siguiente',
    prevPageLabel: 'Pagina anterior',
    rowsPerPageLabel: 'Filas por pagina',
    jumpToPageDropdownLabel: 'Ir a la pagina',
    jumpToPageInputLabel: 'Ir a la pagina',
    selectRow: 'Seleccionar fila',
    unselectRow: 'Deseleccionar fila',
    expandRow: 'Expandir fila',
    collapseRow: 'Contraer fila',
    showFilterMenu: 'Mostrar menu de filtro',
    hideFilterMenu: 'Ocultar menu de filtro',
    filterOperator: 'Operador de filtro',
    filterConstraint: 'Restriccion de filtro',
    editRow: 'Editar fila',
    saveEdit: 'Guardar edicion',
    cancelEdit: 'Cancelar edicion',
    listView: 'Vista de lista',
    gridView: 'Vista de cuadricula',
    slide: 'Diapositiva',
    slideNumber: '{slideNumber}',
    zoomImage: 'Ampliar imagen',
    zoomIn: 'Acercar',
    zoomOut: 'Alejar',
    rotateRight: 'Rotar a la derecha',
    rotateLeft: 'Rotar a la izquierda'
  }
}
